require('./cardChangePaymentMethodSuccessStep.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { PERCENTAGE_SYMBOL, EURO_SYMBOL, CARD_PAYMENT_METHOD_UNIQUE, CARD_PAYMENT_METHOD_FIXED, CARD_PAYMENT_METHOD_VARIABLE } = require('constants/index');

class CardChangePaymentMethodSuccessStep extends React.Component {
    render() {
        const { immCard, currentMethod,immHirePaymentMethod } = this.props;
        const title = immCard.get('isViaT') ? formatText('cardChangePaymentMethodSuccess-successfullyChangedViaT') : formatText('cardChangePaymentMethodSuccess-successfullyChanged');
        const cardAlias = immCard.get('alias').get('current');
       const selectedMethod =currentMethod
         
        const goBackButtonLabel = formatText('cardChangePaymentMethodSuccess-backToCard', [cardAlias]).toUpperCase();
        const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        }
        let installmentsAmount = immHirePaymentMethod.get('value');

        let installmentsSymbol = selectedMethod === CARD_PAYMENT_METHOD_VARIABLE ? PERCENTAGE_SYMBOL : EURO_SYMBOL;
        let paymentMethod;
 
        switch (selectedMethod) {
            case CARD_PAYMENT_METHOD_UNIQUE:
                installmentsAmount = '';
                installmentsSymbol = '';
                paymentMethod = 'cardChangePaymentMethod-unique';
            break;
            case CARD_PAYMENT_METHOD_FIXED:
                paymentMethod = 'cardChangePaymentMethod-fixed';
            break;
            case CARD_PAYMENT_METHOD_VARIABLE:
                paymentMethod = 'cardChangePaymentMethod-variable';
            break;
        }
        return (
            <div className="card-change-payment-method-success col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardSuccess
                    successMessage={title}
                    mainButton={goBackButton}>
                    <section className="row">
                        <div className="col-xs-6 col-md-7">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-6 col-md-5">
                            <FormattedText
                                value="cardChangePaymentMethodSuccess-newMethod"
                                className="card-change-payment-method-success__new-method"
                            />
                            <FormattedText value={paymentMethod} />
                            <span className="card-change-payment-method-success__installments-details">
                            {installmentsAmount} {installmentsSymbol}
                            </span>
                        </div>
                    </section>
                </WizardSuccess>
            </div>
        )
    }
}

CardChangePaymentMethodSuccessStep.propTypes = {
    immCard: PropTypes.object.isRequired,
 };

module.exports = CardChangePaymentMethodSuccessStep;
